"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNumberFormat = require("react-number-format");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _CreditCard = _interopRequireDefault(require("@mui/icons-material/CreditCard"));
var _CheckCircle = _interopRequireDefault(require("@mui/icons-material/CheckCircle"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _theme = require("../../theme");
var _styles = require("@mui/material/styles");
var _excluded = ["inputRef", "onChange"];
var StyledTextField = (0, _styles.styled)(_TextField["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    '& .MuiInputBase-root': {
      fontFamily: '"AvenirLTPro-Book", sans-serif',
      fontWeight: "lighter",
      color: theme.palette["default"].contrastText
    },
    "& .MuiOutlinedInput-root:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):not(.Mui-error):before": {
      borderColor: theme.palette.custom.textFieldHover,
      borderBottomWidth: "2px"
    }
  };
});

/**
 *
 * @param {*} props
 */
function CreditCardFormatCustom(props) {
  var inputRef = props.inputRef,
    onChange = props.onChange,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNumberFormat.PatternFormat, (0, _extends2["default"])({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value
        }
      });
    },
    format: "#### #### #### ####",
    valueIsNumericString: true,
    mask: "_"
  }));
}

/**
 *
 * @param {*} props
 */
var CreditCardInput = function CreditCardInput(props) {
  return props.creditCardSuccess ? /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    id: props.id || props.testid,
    select: props.select,
    error: Boolean(props.error),
    type: "text",
    label: props.label,
    autoFocus: props.autoFocus,
    autoComplete: props.autoComplete,
    value: props.value,
    margin: props.margin || 'normal',
    onChange: props.onChange,
    onKeyPress: props.onKeyPress,
    onBlur: props.onBlur,
    fullWidth: props.fullWidth,
    helperText: props.helperText || props.error,
    InputLabelProps: {
      shrink: props.value
    },
    InputProps: {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_CreditCard["default"], {
        color: "secondary"
      })),
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
        color: "secondary"
      })),
      inputComponent: CreditCardFormatCustom
    },
    sx: {
      "& .MuiOutlinedInput-root": {
        "& > fieldset": {
          borderColor: "".concat(_theme.colors.brandGreen),
          borderWidth: 2,
          borderLeftWidth: 6
        }
      },
      "&:hover .MuiOutlinedInput-root": {
        "& > fieldset": {
          borderColor: "".concat(_theme.colors.brandGreen)
        }
      }
    },
    required: props.required,
    variant: "outlined",
    disabled: props.disabled,
    color: "secondary"
  }) : /*#__PURE__*/_react["default"].createElement(StyledTextField, {
    id: props.id || props.testid,
    select: props.select,
    error: Boolean(props.error),
    type: "text",
    label: props.label,
    value: props.value,
    margin: props.margin || 'normal',
    onChange: props.onChange,
    onKeyPress: props.onKeyPress,
    onBlur: props.onBlur,
    fullWidth: props.fullWidth,
    helperText: props.helperText || props.error,
    InputProps: {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_CreditCard["default"], {
        color: "primary"
      })),
      inputComponent: CreditCardFormatCustom
    },
    style: {
      backgroundColor: props.disabled ? '#f7f7f7' : null
    },
    required: props.required,
    variant: props.variant || 'standard',
    disabled: props.disabled
  });
};
var _default = exports["default"] = CreditCardInput; // const theme = createTheme({
//     typography: {
//         useNextVariants: true,
//         suppressDeprecationWarnings: true
//     },
//     palette: {
//         primary: {
//             main: colors.brandGreen
//         }
//     },
//     overrides: {
//         MuiOutlinedInput: {
//             root: {
//                 '& fieldset': {
//                     borderColor: `${ colors.brandGreen } !important`,
//                     borderWidth: 2,
//                     borderLeftWidth: 6
//                 }
//             }
//         }
//     }
// });